const TandCfooter = props => {
    return(
        <footer className="bg-graylight-3 padd-5 text-left terms-section">
            <p className="text-medium tncs text-black">{props.info}</p>
        </footer>

    )
}
export default TandCfooter